
import { throwError as observableThrowError, Observable } from 'rxjs';

import { Injectable, Injector } from '@angular/core';

import { Router } from '@angular/router';

import * as _ from 'lodash-es';

import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { NbAuthService } from '@nebular/auth';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(private injector: Injector, private _router: Router) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const authService = this.injector.get(NbAuthService);

        // console.info('TokenInterceptor ' + req.url);

        const _this = this;
        return authService.getToken()
            .pipe(switchMap(function (token) {
                if (token && token.getValue()) {
                    // console.info("adding token " + token.getValue());
                    req = req.clone({
                        headers: req.headers.set('Authorization', 'Bearer ' + token.getValue()),
                    });
                    // console.info("headers " + JSON.stringify(req.headers));
                }
                return next.handle(req);
            }));
    }
}
